import { MotionDiv } from '@thg-commerce/gravity-animations'
import { styled, spacing, css } from '@thg-commerce/gravity-theme'

export const AnimatedKnob = styled(MotionDiv)`
  width: ${spacing(2.5)};
  height: ${spacing(2.5)};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.palette.brand.base};
  top: -${spacing(0.75)};
  position: absolute;
  left: -${spacing(1)};

  &:hover {
    outline: ${spacing(0.875)} solid
      ${({ theme }) => theme.colors.palette.brand.lighter};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.palette.brand.darker};
    box-shadow: 0 0 0 ${spacing(0.5)}
      ${({ theme }) => theme.colors.palette.brand.lighter};
    outline-offset: ${spacing(0.5)};
    outline: ${spacing(0.25)} solid
      ${({ theme }) => theme.colors.palette.brand.base};
  }
`

export const Track = styled(MotionDiv)<{
  minPercentage: number
  maxPercentage: number
}>`
  width: 100%;
  height: 8px;
  background-color: ${({ theme }) => theme.colors.palette.brand.base};
  border-radius: 4px;
  position: relative;
  ${({ minPercentage, maxPercentage, theme }) => css`
    background: linear-gradient(
      to right,
      ${theme.colors.palette.greys.light} 0%,
      ${theme.colors.palette.greys.light} ${minPercentage.toFixed(2)}%,
      ${theme.colors.palette.brand.base} ${minPercentage.toFixed(2)}%,
      ${theme.colors.palette.brand.base} ${maxPercentage.toFixed(2)}%,
      ${theme.colors.palette.greys.light} ${maxPercentage.toFixed(2)}%
    );
  `}
`

export const Container = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  margin: ${spacing(2)} 0 ${spacing(3)};
`
